import React from "react";
import AgentInfoCard from "../AgentInfoCard";
import Hero from "../../Home/Hero";
import styled from "styled-components";
import { useAgentHero } from "./hooks/useAgentHero";

/**
 * The Agent Hero component.
 * @param {string} agentName - The name of the agent.
 * @param {array} agentMedia - An array of objects containing agent media items.
 * @param {object} agentImage - A fallback for an agent that has agentInfo w/o agentMedia data.
 * @returns The hero section of the agent page.
 */
const AgentHero = ({ agentName, agentMedia = [], agentImage = {} }) => {
    const { heroDesktopPath, heroMobilePath, hasHeroImage } = useAgentHero({
        agentMedia,
    });

    return (
        <AgentHeroWrapper
            path={heroDesktopPath}
            mobilePath={heroMobilePath}
            mobileHeight="400px"
        >
            <div className="hero-content-wrapper d-flex flex-column flex-md-row gap-4 py-4 py-md-5 container-lg">
                {agentImage?.imageUrl && (
                    <div
                        data-testid="agent-image-wrapper"
                        className={`agent-image-wrapper justify-content-center d-flex me-md-3 ${
                            hasHeroImage ? "has-hero-image" : ""
                        }`}
                    >
                        <div
                            className={`align-content-center ${
                                hasHeroImage ? "pb-4 pb-md-0" : ""
                            }`}
                        >
                            <div className="d-inline-block rounded shadow bg-white p-3">
                                <img
                                    className="agent-photo"
                                    src={
                                        agentImage?.imageUrl ||
                                        "/assets/no-image-found-360x260.png"
                                    }
                                    onError={(e) =>
                                        (e.target.src =
                                            "/no-image-found-360x260.png")
                                    }
                                    alt={agentName || "Agent"}
                                    data-test="agent-photo"
                                />
                            </div>
                        </div>
                    </div>
                )}

                <AgentInfoCard className="bg-white p-3 rounded shadow ms-md-auto flex-grow-1" />
            </div>
        </AgentHeroWrapper>
    );
};

const AgentHeroWrapper = styled(Hero)`
    background-color: var(--bs-gray-200);
    .hero-content-wrapper {
        min-height: 400px;
        max-width: 950px;
        position: relative;
        .agent-image-wrapper {
            width: 300px;
            min-width: 300px;
            > div {
                max-width: 100%;
            }
        }
        .agent-photo {
            width: 100%;
        }
        @media (max-width: 767px) {
            .agent-image-wrapper {
                width: 100%;
                min-width: auto;
                &.has-hero-image {
                    height: 376px;
                }
            }
            .agent-photo {
                max-height: 300px;
                max-width: 275px;
                width: auto;
            }
        }
    }
`;

export default AgentHero;
